module.exports = __webpack_public_path__ + "img/Loader.750fc7f7.gif";